import { TaxPricePeriodTranslationAdminzoneState } from "@/types/store/adminzone/tax_price_period_translation";
import { TaxPricePeriodTranslationData } from "@/types/tax_price_period_translation";

export const state: TaxPricePeriodTranslationAdminzoneState = {
  taxPricePeriodTranslation: [] as Array<TaxPricePeriodTranslationData>
}
